export default {
  'purchasesPurchaseReport.form.filterByDate': 'Filter by date',
  'purchasesPurchaseReport.form.filterByDate.launch': 'Launch',
  'purchasesPurchaseReport.form.filterByDate.emission': 'Emission',

  'purchasesPurchaseReport.form.situation': 'Situation',
  'purchasesPurchaseReport.form.situation.open': 'Open',
  'purchasesPurchaseReport.form.situation.authorized': 'Authorized',
  'purchasesPurchaseReport.form.situation.canceled': 'Canceled',

  'purchasesPurchaseReport.form.itemsPurchase': 'Items Purchase',
  'purchasesPurchaseReport.form.itemsPurchase.parts': 'Parts',
  'purchasesPurchaseReport.form.itemsPurchase.consumables': 'Consumables',
  'purchasesPurchaseReport.form.itemsPurchase.tasks': 'Tasks',
  'purchasesPurchaseReport.form.itemsPurchase.freightInvoice':
    'Freight Invoice',

  'purchasesPurchaseReport.form.groupReportBy': 'Group report by',
  'purchasesPurchaseReport.form.groupReportBy.date': 'Date',
  'purchasesPurchaseReport.form.groupReportBy.supplier': 'Supplier',
  'purchasesPurchaseReport.form.groupReportBy.workOders': 'Workoders',
  'purchasesPurchaseReport.form.groupReportBy.cfop': 'CFOP',
  'purchasesPurchaseReport.form.groupReportBy.documentType': 'Document Type',

  'purchasesPurchaseReport.form.purchaseCode': 'Purchase Code',
  'purchasesPurchaseReport.form.accessKey': 'Access Key',
  'purchasesPurchaseReport.form.documentNumber': 'Document number',

  'purchasesPurchaseReport.form.moreOptions': 'More Options',
  'purchasesPurchaseReport.form.moreOptions.button.selectSuppliers':
    'Select Suppliers',
  'purchasesPurchaseReport.form.moreOptions.button.selectDocumentType':
    'Select Document Type',
  'purchasesPurchaseReport.form.moreOptions.button.selectCfop': 'Select Cfop',
  'purchasesPurchaseReport.form.moreOptions.button.selectWorkOrder':
    'Select Workorder',
};
